import _extends from "@babel/runtime/helpers/extends";

/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@emotion/core';
import Button from '@atlaskit/button/standard-button';
import { gridSize as getGridSize } from '@atlaskit/theme/constants';
var gridSize = getGridSize();
var navigatorStyles = css({
  paddingRight: gridSize / 2,
  paddingLeft: gridSize / 2
});
export default function Navigator(props) {
  return jsx(Button, _extends({}, props, {
    appearance: "subtle",
    spacing: "none",
    css: navigatorStyles
  }));
}